import { useMutation } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { inviteWitnessToSign } from '@dealstack/frontend/shared/dataExchange/services/shareholder/investment.service';

export const useInviteWitness = () => {
	return useMutation({
		mutationKey: [
			API_PATHS.DEAL_DEALID_MIP_PROGRAMMEID_DOCUMENT_WORKFLOW_DOCUMENTWORKFLOWINSTANCEID_INVITE_WITNESS_POST,
		],
		mutationFn: inviteWitnessToSign,
	});
};
